export default __webpack_public_path__ + "static/media/logo-asocar.5b758c50.png";